import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Form } from "../../../base/views/useForm";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(1, 0, 1),
  },
}));

const initialFValues = {
  physicalInventoryId: 0,
  barcode: "",
  ndc: "",
  packs: "",
  looseQty: "0.000",
  comments: "",
};

export default function PhysicalInventoryForm(props) {
  const classes = useStyles();
  const [errors, setErrors] = React.useState({});
  const [addPhysicalInventoryData, setState] = useState(initialFValues);

  const {
    addOrEdit,
    recordForEdit,
    editPhysicalInventory,
  } = props;

  const validate = (fieldValues = addPhysicalInventoryData) => {
    let temp = { ...errors };

    if ("packsize" in fieldValues) {
      temp.packsize =
        fieldValues.packsize === "" ? "Pack Size is required" : "";
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...addPhysicalInventoryData,
      [name]: value,
    });
  };

  const HandleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      editPhysicalInventory({
        storeid: props.storeid,
        userid: props.userid,
        ndc: addPhysicalInventoryData.ndc,
        upc: addPhysicalInventoryData.upc,
        packs: addPhysicalInventoryData.packs,
        loose_qty: addPhysicalInventoryData.loose_qty,
        comments: addPhysicalInventoryData.comments,
      });
      addOrEdit(resetForm);
    }
  };

  const resetForm = () => {
    setState(initialFValues);
    setErrors({});
  };

  useEffect(() => {
    if (recordForEdit != null)
      setState({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  return (
    <Form onSubmit={HandleSubmit}>
      <Container component="main" maxWidth="lg">
        <div className={classes.form}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextField
                value={addPhysicalInventoryData.barcode}
                variant="outlined"
                fullWidth
                id="barcode"
                label="Barcode"
                name="barcode"
                autoComplete="barcode"
                disabled
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addPhysicalInventoryData.ndc}
                variant="outlined"
                fullWidth
                id="ndc"
                label="NDC"
                name="ndc"
                autoFocus
                autoComplete="ndc"
                {...(errors.ndc && {
                  error: true,
                  helperText: errors.ndc,
                })}
                disabled
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addPhysicalInventoryData.packs}
                autoFocus
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="packs"
                label="Packs"
                name="packs"
                autoComplete="packs"
                {...(errors.packs && {
                  error: true,
                  helperText: errors.packs,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addPhysicalInventoryData.looseQty}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="looseQty"
                label="Loose Qty"
                name="looseQty"
                InputProps={{ inputProps: { min: "0.000", step: "0.001" } }}
                autoComplete="looseQty"
                {...(errors.looseQty && {
                  error: true,
                  helperText: errors.looseQty,
                })}
                type="number"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addPhysicalInventoryData.comments}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="comments"
                label="Comments"
                name="comments"
                autoComplete="comments"
                multiline
                rows={4}
              />
            </Grid>
          </Grid>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              style={{ width: "20vw" }}
              type="submit"
            >
              Save
            </Button>
          </div>
        </div>
      </Container>
    </Form>
  );
}